import React from 'react';
import PropTypes from 'prop-types';
import { TextField, InputAdornment } from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';

/**
 * Search field component for filtering keywords
 *
 * @param {Object} props Component props
 * @param {string} props.searchQuery Current search query
 * @param {Function} props.onSearchChange Function to handle search query changes
 * @returns {JSX.Element} Rendered search field component
 */
const KeywordSearchField = ({ searchQuery, onSearchChange }) => {
  return (
    <TextField
      fullWidth
      size="small"
      placeholder="Search keywords..."
      value={searchQuery}
      onChange={(e) => onSearchChange(e.target.value)}
      sx={{
        mb: 3,
        '& .MuiOutlinedInput-root': {
          backgroundColor: 'white',
        },
      }}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon color="action" />
          </InputAdornment>
        ),
      }}
    />
  );
};

KeywordSearchField.propTypes = {
  searchQuery: PropTypes.string.isRequired,
  onSearchChange: PropTypes.func.isRequired,
};

export default KeywordSearchField;
